import React from "react";
import { BrowserRouter, Route, Redirect } from "react-router-dom";

import Home from "./components/Home/Home";
import About from "./components/About/About";
import News from "./components/News/News";
import Gallery from "./components/Gallery/Gallery";
import Contact from "./components/Contact/Contact";
import Donate from "./components/Donate/Donate";
import Admin from "./components/Admin/Admin";
import Login from "./components/Login/Login";
import RecipientRegister from "./components/RecipientRegister/RecipientRegister";
import Supporters from "./components/Supporters/Supporters";
import GetTickets from "./components/GetTickets/GetTickets";
import RegisterSuccess from "./components/RegisterSuccess/RegisterSuccess";

class Main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {}
        };

        this.setUser = this.setUser.bind(this);
        this.getUser = this.getUser.bind(this);
        this.logout = this.logout.bind(this);
    }

    setUser(newUser) {
        this.setState({user: newUser});
    }

    getUser() {
        return this.user;
    }

    logout() {
        this.setUser({});
    }
    
    render() {
        return (
            <BrowserRouter>
                <Route exact path="/" render={(p) => {
                        window.scroll(0,0);
                        return <Home/>
                    }}>
                </Route>
                <Route exact path="/about" render={(p) => {
                        window.scroll(0,0);
                        return <About/>
                    }}>
                </Route>
                <Route exact path="/news" render={(p) => {
                        window.scroll(0,0);
                        return <News/>
                    }}>
                </Route>
                <Route exact path="/gallery" render={(p) => {
                        window.scroll(0,0);
                        return <Gallery/>
                    }}>
                </Route>
                <Route exact path="/contact" render={(p) => {
                        window.scroll(0,0);
                        return <Contact/>
                    }}>
                </Route>
                <Route exact path="/donate" render={(p) => {
                        window.scroll(0,0);
                        return <Donate/>
                    }}>
                </Route>

                <Route exact path="/supporters" render={(p) => {
                        window.scroll(0,0);
                        return <Supporters/>
                    }}>
                </Route>

                <Route exact path="/logout" render={(p) => {
                                this.logout();
                                return <Redirect to="/"/>
                            }}>
                </Route>
                <Route exact path="/login" 
                            render={(p) => {
                                window.scroll(0,0);
                                if (this.state.user === {}) {
                                    return <Redirect to="/"/>
                                } else if (this.state.user.email === "rae@kidsinseats.org") {
                                    return <Redirect to="/admin"/>
                                } else if (this.state.user.email && this.state.user.approved && this.state.user.paid) {
                                    return <Redirect to="/get-tickets"/>
                                } else if (this.state.user.email){
                                    return <Redirect to="/registersuccess"/>
                                } else {
                                    return <Login {...p} setUser={this.setUser}/>
                                }
                            }}>
                </Route>

                <Route exact path="/admin" 
                            render={(p) => {
                                window.scroll(0,0);
                                if(this.state.user.email === "rae@kidsinseats.org") {
                                    return <Admin {...p} get={this.getUser}/>
                                } else {
                                    return <Redirect to="/login"/>
                                }
                            }}>
                </Route>

                <Route exact path="/register"  
                            render={(p) => {
                                window.scroll(0,0);
                                if (this.state.user.email) {
                                    return <Redirect to="/get-tickets"/>
                                } else {
                                    return <RecipientRegister {...p} setUser={this.setUser}/>
                                }
                            }}>
                </Route>
                <Route exact path="/registersuccess" render={(p) => {
                    window.scroll(0,0);
                    return <RegisterSuccess/>;
                }}>
                </Route>
                <Route exact path="/get-tickets" render={(p) => {
                                window.scroll(0,0);
                                if (this.state.user.email === "rae@kidsinseats.org") {
                                    return <Redirect to="/admin"/>
                                } else if (this.state.user.email && this.state.user.approved && this.state.user.paid) {
                                    return <GetTickets {...p}  user={this.state.user}/>
                                } else if (this.state.user.email) {
                                    return <Redirect to="/registersuccess"/>
                                } else {
                                    return <Redirect to="/"/>
                                }
                            }}>
                </Route>

            </BrowserRouter>
        );
    }
}

export default Main;
